import { Button } from "@/components/ui/button";
import { Cpu, HardDrive, MemoryStick, Monitor, FileCode, DoorOpen, MessageCircle, Lock } from "lucide-react";
import { motion } from "framer-motion";

const specs = [
  { icon: Cpu, label: 'CPU', value: 'Intel i3 2,8 GHz | AMD Athlon II 2,8 GHz' },
  { icon: MemoryStick, label: 'GPU', value: 'NVIDIA GeForce 2xx | AMD Radeon HD 5xxx' },
  { icon: HardDrive, label: 'Memoria RAM', value: '6 GB' },
  { icon: Monitor, label: 'Sistema Operativo', value: 'Windows 7 en adelante' },
  { icon: FileCode, label: 'Espacio en disco', value: '5 GB' },
  { icon: FileCode, label: 'Versión de Java', value: 'Java 17' },
];

// Jartiland 11 terminó: el formulario (`ApplicationForm`) ya no se monta. Sigue
// en el repo para la próxima edición.
export default function ApplyPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="relative overflow-hidden border-b border-white/8 py-20 text-center">
        <div className="absolute -top-32 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" />
        <div className="container relative mx-auto max-w-3xl px-4">
          <motion.div
            className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-primary/30 bg-primary/10"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
          >
            <DoorOpen className="h-7 w-7 text-primary" />
          </motion.div>
          <motion.h1
            className="font-headline text-5xl font-bold md:text-7xl"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="bg-gradient-to-r from-primary to-amber-500 bg-clip-text text-transparent">Formulario de Acceso</span>
          </motion.h1>
        </div>
      </header>

      <main className="container mx-auto max-w-2xl px-4 py-16">
        <div className="space-y-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="relative overflow-hidden rounded-2xl border border-primary/40 bg-primary/10 p-8 text-center shadow-[0_0_40px_rgba(250,204,21,0.15)]"
          >
            <div className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-primary to-amber-500" />
            <Lock className="mx-auto h-10 w-10 text-primary" />
            <p className="mt-4 font-headline text-2xl font-bold md:text-3xl">Jartiland 11 ha finalizado</p>
            <p className="mt-2 text-lg text-muted-foreground">Los formularios están cerrados.</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5 }}
            className="relative overflow-hidden rounded-2xl border border-white/8 bg-card/40 p-6 backdrop-blur-sm md:p-8"
          >
            <div className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-primary to-amber-500" />

            <h2 className="font-headline text-xl font-bold">Requisitos</h2>
            <p className="mt-1 text-sm text-muted-foreground">
              Antes de aplicar, asegúrate de cumplir con los siguientes requisitos para una experiencia de juego óptima.
            </p>

            <div className="mt-6 flex flex-col items-center justify-between gap-3 rounded-2xl bg-muted/40 p-4 sm:flex-row">
              <p className="text-sm font-medium text-center sm:text-left">Estar dentro del servidor de Discord de Jartiland.</p>
              <Button asChild className="w-full sm:w-auto">
                <a href="https://discord.gg/rmJGq5YbTE" target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="h-4 w-4" />
                  Unirse a Discord
                </a>
              </Button>
            </div>

            <div className="mt-6">
              <h3 className="mb-3 text-sm font-semibold text-muted-foreground">Especificaciones Mínimas</h3>
              <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                {specs.map((spec) => (
                  <div key={spec.label} className="flex items-start gap-3 rounded-xl bg-muted/40 p-3">
                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                      <spec.icon className="h-4 w-4" />
                    </div>
                    <div className="text-sm">
                      <span className="font-semibold text-foreground">{spec.label}:</span>{' '}
                      <span className="text-muted-foreground">{spec.value}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
